import React from 'react';
import { useSelector } from 'react-redux';

const SurveyPreview = () => {
  const { html = '', configuration } = useSelector(
    (state) => state.engage.communication.communicationPreview
  );
  const getUnit = (unit) => {
    switch (unit) {
      case 'PERCENT':
        return '%';
      case 'DP':
        return 'px';
      default:
        return 'px';
    }
  };
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      {html && (
        <iframe
          srcDoc={html}
          seamless
          loading="lazy"
          id="onSite_desktop_iframe"
          sandbox="allow-same-origin allow-scripts allow-popups"
          frameBorder={0}
          style={{
            margin: 0,
            visibility: html ? 'visible' : 'hidden',
            overflowY: 'hidden',
            overflowX: 'hidden',
            bottom: '0px',
            position: 'absolute',
          }}
          onLoad={() => {
            const iframe = document.getElementById('onSite_desktop_iframe');
            const w = configuration?.fallbackMetric.width.value;

            const wUnit = getUnit(configuration?.fallbackMetric.width.unit);
            const h = configuration?.fallbackMetric.height.value;
            const hUnit = getUnit(configuration?.fallbackMetric.height.unit);

            iframe.width = `${w}${wUnit}`;
            iframe.height = `${h}${hUnit}`;
          }}
        />
      )}
    </div>
  );
};

export default SurveyPreview;
